import { render, staticRenderFns } from "./RelacaoEtapasFiltro.vue?vue&type=template&id=0b66a090"
import script from "./RelacaoEtapasFiltro.vue?vue&type=script&lang=js"
export * from "./RelacaoEtapasFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports